<template>
  <w-dialog :dialog-show="state" @handleClose="handleClose">
    <div slot="content" class="edit-content" :class="{'edit-content-member': editType === 'member'}" @touchmove.prevent>
      <div class="edit-header flex-between">
        <span class="member-title">{{ editType === 'member' ? '简历分数已达上限' : '升级会员，继续编辑' }}</span>
        <span class="iconfont iconx" @click="handleClose"/>
      </div>
      <p class="desc">{{ editType === 'member' ? '免费版仅可编辑一份简历，升级会员可继续编辑，是否需要继续编辑？'
        : '免费版仅可编辑 1 份中文简历，1 份英文简历' }}</p>
      <div class="select-cv" v-if="editType !== 'member'">
        <div class="select-item" v-for="(item, index) in selectOption" :key="index">
          <p class="select-title">{{ item.title }}</p>
          <w-select :options="item.options" :field="item.field" @selectValue="changeValue"/>
        </div>
      </div>
      <div class="edit-footer">
        <div v-if="editType === 'member'">
          <button class="theme-button flex-center member-btn" @click="editClick('member')">升级会员</button>
          <button class="white-button flex-center member-btn" @click="handleDownload">下载简历</button>
        </div>
        <div v-else class="flex-between">
          <button class="white-button flex-center choose-cv-btn" @click="editClick('select')"
                  :disabled="!req.cn_token && !req.en_token">确定选择简历
          </button>
          <button class="theme-button flex-center" @click="editClick('member')">升级超级会员</button>
        </div>
      </div>
    </div>
  </w-dialog>
</template>

<script>
	import WDialog from '@/components/global/w-dialog'
	import WSelect from '@/components/global/w-select'
	import { componentsMixin } from '../../assets/js/mixin/components'

	export default {
		props: {
			state: {
				type: Boolean,
				default: false
			},
			editType: {
				type: String,
				default: ''
			},
			selectOption: {
				type: Array,
				default: () => []
			},
      currentCvData: {
        type: Object,
        default: () => {
          return {}
        }
      }
		},
		mixins: [ componentsMixin ],
		data () {
			return {
				req: {}
			}
		},
		mounted () {
		},
		components: {
			WDialog,
			WSelect
		},
		watch: {},
		computed: {
			disabled () {
				return !this.req.token
			}
		},
		methods: {
			handleClose () {
				this.$emit('handleClose')
			},
			// 继续编辑的弹窗确定事件
			async editClick (type) {
				if (type === 'select') {
					let cnPayload = {
						token: this.req.cn_token,
						lang: 'cn'
					}
					let enPayload = {
						token: this.req.en_token,
						lang: 'en'
					}
					let cnRes = {}, enRes = {}
					if (this.req.cn_token) cnRes = await this.$api.cv.editableCv(cnPayload)
					if (this.req.en_token) enRes = await this.$api.cv.editableCv(enPayload)
					if (cnRes.code === 1000 || enRes.code === 1000) {
						this.$emit('refresh', [ this.req.cn_token, this.req.en_token ], 'editable')
						this.handleClose()
					} else {
						this.showToast(cnRes.message)
					}
				} else if (type === 'member') {
					if (this.$isWxMini) {
            // this.$wechat.miniProgram.navigateTo({ url: '/pages/customService/customService' })
            // this.$wechat.miniProgram.navigateTo({ url: `/pages/memberPay/memberPay` })
            if (this.mobileOS === 'iOS') {
              this.$wechat.miniProgram.navigateTo({
                // url: `/pages/customService/customService`
                url: `/pages/memberPay/memberPay`
              })
            } else {
              this.$router.push('/buy/member/order')
            }
					} else {
						// this.$api.user.createImprovedOrder(
						// 	{
						// 		from_vue: 'true',
						// 		improved_order: { package: 'membership' }
						// 	}).then(res => {
						// 	if (res.code === 1000) {
						// 		window.location.href = process.env.VUE_APP_LINK + `/orders/${ res.data.order_token }`
						// 	}
						// })
            this.$router.push({path:'/buy/member/order'})
          }
				}
			},
			changeValue (item, field) {
				this.req[field] = item.value
				this.$forceUpdate()
			},
      handleDownload() {
        this.$router.push({
          path: '/cvs/send-email',
          query: {
            hideProfile: false,
            token: this.currentCvData.token,
            cv_name: this.currentCvData.cv_name
          }
        })
      }
		}
	}
</script>
<style scoped lang="scss">
  @import '@/assets/scss/global/variable';
  .edit-content {
    position: relative;
    width: 90vw;
    background-color: $color-light;
    border-radius: 6px;
    box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
    padding: 24px 24px;
    box-sizing: border-box;
    .edit-header {
      font-size: $font-size-large;
      font-weight: 500;
      color: $color-title;
      margin-bottom: 20px;
      .iconfont {
        color: #8c8c8c;
        font-weight: bold;
        font-size: 18px;
      }
    }
    .desc {
      color: $color-dark-gray;
      line-height: 24px;
      margin-bottom: 16px;
    }
    .select-cv {
      .select-item {
        margin-bottom: 16px;
        .select-title {
          color: $color-title;
          font-weight: 500;
          margin-bottom: 10px;
        }
      }
    }
    .edit-footer {
      margin-top: 16px;
      button {
        border-radius: 4px;
        height: 40px;
        padding: 0 22px;
        font-size: $font-size-medium-x;
        white-space: nowrap;
        &:disabled {
          background-color: #cfcfcf;
          color: $color-light;
          border: none;
        }
      }
      .member-btn {
        width: 100%;
      }
      button:disabled {
        background-color: #ececec;
        color: $color-dark-gray;
      }
    }
  }
  .edit-content-member {
    .edit-header {
      justify-content: center;
      margin-bottom: 16px;
      .member-title {
        line-height: 26px;
        font-size: $font-size-large;
        color: $color-title;
        font-weight: 600;
      }
      .iconfont {
        position: absolute;
        top: 28px;
        right: 24px;
      }
    }
    .desc {
      line-height: 20px;
      color: $color-title;
      font-weight: 400;
      margin-bottom: 18px;
    }
    .edit-footer {
      .member-btn {
        height: 40px;
        border-radius: 23px;
        font-weight: 500;
      }
      .member-btn:last-child {
        margin-top: 10px;
        color: $color-dark-gray;
        border-color: #ececec;
      }
    }
  }
</style>
